export default "__VITE_ASSET__CUO3ja1B__"